import { Form, Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';

import { AssetDetailTitle } from 'app/components/commons/AssetDetailTitle/AssetDetailTitle';
import { Spinner } from 'app/components/commons/Spinner/Spinner';

import './RoomFormContainer.scss';
import { RoomDetailHeader } from './components/RoomDetailHeader';
import { RoomForm } from './components/RoomForm';
import { useRoomActions } from './hooks/useRoomActions';
import { useRoomData } from './hooks/useRoomData';

export const RoomFormContainer = () => {
  const roomData = useRoomData();
  const {
    roomId,
    isCreatePage,
    fetchedRoom,
    hotel,
    hotels,
    initialValues,
    isDataLoaded,
    title,
    buttonSaveText,
  } = roomData;

  const roomActions = useRoomActions({
    roomId,
    isCreatePage,
    fetchedRoom,
    hotels,
    initialValues,
  });

  const {
    form,
    mode,
    canSubmit,
    isLoading,
    onFinish,
    onCancel,
    handleDelete,
    handleSave,
    enterEditMode,
    setCanSubmit,
  } = roomActions;

  const selectedHotelId = Form.useWatch(['hotelId'], form);
  const displayedHotel =
    hotels?.find(({ id }) => id === selectedHotelId) ?? hotel;

  if (!roomId && !isCreatePage) {
    return null;
  }

  return (
    <Layout className={'room-form'}>
      <RoomDetailHeader
        isCreatePage={isCreatePage}
        roomId={roomId}
        mode={mode}
        canSubmit={canSubmit}
        isLoading={isLoading}
        onEdit={enterEditMode}
        onSave={handleSave}
        onCancel={onCancel}
        onDelete={handleDelete}
        title={
          <AssetDetailTitle
            assetTitle={title}
            hotelId={displayedHotel?.id}
            hotelName={displayedHotel?.name}
            isNewDataModel={
              displayedHotel ? !displayedHotel.isLegacy : undefined
            }
          />
        }
        buttonSaveText={buttonSaveText}
        showDelete={!isCreatePage}
      >
        <Content className="room-details__content">
          {isDataLoaded ? (
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              initialValues={initialValues}
              onFieldsChange={(_, allFields) => {
                const hasFormErrors = allFields.some(
                  (field) => field.errors && field.errors.length > 0
                );

                setCanSubmit(!hasFormErrors);
              }}
            >
              <RoomForm />
            </Form>
          ) : (
            <Spinner />
          )}
        </Content>
      </RoomDetailHeader>
    </Layout>
  );
};
